import * as React from "react";
import { useSelector } from "react-redux";
import { WaterfallContent } from "../../../components/waterfall";
import styles from "../index.scss";
import { RootState } from "../../../store/configureStore";
import { FormattedMessage } from "react-intl";
import * as htmlParser from "html-to-text";
import classNames from "classnames";
import uniqBy from "lodash/uniqBy";
import { useContext } from "react";
import { BusinessContext } from "../../BusinessContext";
import Icon from "../../../components/icon";
import replaceState from "../../../helpers/reolaceState";
import { Avatar, Space, Image, Row } from "antd";
import dilogoImg from "../../../static/img/dilogo.png";
import { Link, Paragraph } from "../../../wrappers/typography";
import Button from "../../../wrappers/button";
import { useTheme } from "styled-components";

interface IdeaCardProps {
  src: string;
  name: string;
  shopName: string;
  url: string;
  designerName: string;
  designerAvatar: string;
  likeNum: number;
  tags:
    | string
    | {
        shop_product_id: number;
        coordinate_x: number;
        coordinate_y: number;
        url: string;
      }[];

  isCollect: boolean;

  showMask?: boolean;

  onChangeUserLike?: () => void;
  onChangeLikeIdea: () => void;

  htmlMounted?: () => void;

  showName?: boolean;
  showTag?: boolean;
  shopUrl: string;

  showSwitch?: boolean;
  isMobile?: boolean;

  description?: string;

  showTitle?: boolean;

  className?: string;

  outsideRef?: boolean;
  isMegaBook?: boolean;

  showCollection?: boolean;
  isLike: boolean;
}

const IdeaCard = (props: IdeaCardProps) => {
  // const { search = "" } = useSelector((state: RootState) => state.URLSearch);
  const {
    template,
    primaryColor,
    secondaryColor,
    textColor,
    linkColor,
    bussinessPrimaryColor,
  } = useTheme();
  const { isToBusiness } = useContext(BusinessContext);
  const [hover, setHover] = React.useState(false);
  const [isLoaded, setIsLoaded] = React.useState(false);
  const [stateShowTag, setStateShowTag] = React.useState(true);
  const { onWaterFall } = React.useContext(WaterfallContent);
  const {
    src,
    name,
    shopName,
    designerName,
    designerAvatar,
    url,
    isCollect,
    showMask,
    showName,
    showTag,
    shopUrl = "",
    showSwitch,
    isMobile,
    // itemWidth
    htmlMounted,
    description,
    showTitle = true,
    className,
    outsideRef,
    showCollection = true,
    likeNum,
    isLike,
    isMegaBook = false,
    onChangeLikeIdea,
  } = props;

  const handleHover = () => {
    if (hover) {
      setHover(false);
    } else {
      setHover(true);
    }
  };

  const handleLoad = (isload: boolean) => {
    try {
      onWaterFall();
    } catch (error) {
      // console.log(error);
    }

    if (!isload) {
      setIsLoaded(true);
    }
  };

  const unactiveTags =
    props.tags === undefined || typeof props.tags === "object"
      ? props.tags
      : JSON.parse(props.tags);

  const tags = uniqBy(unactiveTags, "coordinate_index");

  const isShow = isMobile ? showTag || stateShowTag : hover || outsideRef;

  React.useEffect(() => {
    htmlMounted && htmlMounted();
  }, []);

  const descText = htmlParser.fromString(description);

  if (template && !outsideRef) {
    return (
      <div
        className={classNames(styles["ideas-card"], className, "imgBox")}
        onMouseEnter={handleHover}
        onMouseLeave={handleHover}
      >
        <div style={{ position: "relative" }}>
          <div style={{ position: "relative" }}>
            <a
              onClick={() => {
                replaceState.linkTo(url);
              }}
            >
              {/* <img
                src={src}
                onLoad={() => handleLoad(isLoaded)}
                style={{ borderRadius: "5px 5px 0 0" }}
              /> */}
              <Image
                onLoad={() => handleLoad(isLoaded)}
                preview={false}
                src={src}
                width="100%"
                height="100%"
                style={{ borderRadius: "5px 5px 0 0" }}
                // fallback="data:image/png;base64,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"
                // placeholder={
                //   <div
                //     style={{
                //       height: "100%",
                //       width: "100%",
                //       backgroundColor: "#ddd",
                //     }}
                //   />
                // }
              />
            </a>
            {(isLoaded || outsideRef) &&
              isShow &&
              Array.isArray(tags) &&
              tags.map((item, index) => (
                <a
                  onClick={() => {
                    replaceState.linkTo(item.url || url);
                  }}
                  key={index}
                  style={{
                    left: `calc(${
                      (item[0] || item.coordinate_x) * 100
                    }% - 15px)`,
                    top: `calc(${
                      (item[1] || item.coordinate_y) * 100
                    }% - 15px)`,
                    ...(item[2]
                      ? {
                          width: `30px`,
                          height: `30px`,
                        }
                      : {}),
                  }}
                  className={styles["ideas-card-tag"]}
                >
                  <div>
                    <Icon type="icont2_biaoqian"></Icon>
                  </div>
                </a>
              ))}
          </div>

          <div className={styles["ideas-template-card-title"]}>
            <p>
              <Link
                onClick={() => {
                  replaceState.linkTo(url);
                }}
                style={{ color: "#666", fontSize: "1.1rem" }}
              >
                <Paragraph ellipsis={{ rows: 2 }}> {name} </Paragraph>
              </Link>
            </p>
            <div>
              <Space>
                <Avatar src={designerAvatar ?? dilogoImg} size={26} />
                <Link>{designerName ?? "未命名设计师"}</Link>
              </Space>
              {!isMegaBook && (
                <Link onClick={() => onChangeLikeIdea()} color={textColor}>
                  <Space size={3}>
                    <Icon
                      type={isLike ? "icondianzan" : "icondianzan_xian"}
                      style={{
                        color: isLike ? primaryColor : "",
                      }}
                    ></Icon>
                    {likeNum}
                  </Space>
                </Link>
              )}
            </div>
          </div>
        </div>
        {showCollection && (isLoaded || outsideRef) && isShow && (
          <div
            className={styles["ideas-userLike"]}
            onClick={props.onChangeUserLike}
          >
            <Button
              shape="circle"
              icon={
                <Icon type={isCollect ? "icont2_shoucang1" : "iconshoucang1"} />
              }
              color={isToBusiness ? bussinessPrimaryColor : primaryColor}
            />
          </div>
        )}
      </div>
    );
  }

  return (
    <div
      className={classNames(styles["ideas-card"], className)}
      onMouseEnter={handleHover}
      onMouseLeave={handleHover}
    >
      {props.onChangeUserLike && (isLoaded || outsideRef) && isShow && (
        <div
          className={styles["ideas-userLike"]}
          onClick={props.onChangeUserLike}
        >
          {template && (
            <Button
              shape="circle"
              icon={
                <Icon type={isCollect ? "icont2_shoucang1" : "iconshoucang1"} />
              }
              color={isToBusiness ? bussinessPrimaryColor : primaryColor}
            />
          )}
        </div>
      )}

      <div style={{ position: "relative" }}>
        {!isLoaded && !outsideRef && (
          <div style={{ width: "100%" }} className={styles["ideas-img-mask"]} />
        )}
        <a
          onClick={() => {
            replaceState.linkTo(url);
          }}
        >
          <img src={src} onLoad={() => handleLoad(isLoaded)} />
        </a>
        {descText && (
          <div
            className={styles["ideas-card-description-mask"]}
            style={{
              display:
                (isMobile && stateShowTag) || (!isMobile && hover) || outsideRef
                  ? ""
                  : "none",
            }}
          >
            <div className={styles["ideas-card-description-short"]}>
              {htmlParser.fromString(description)}
            </div>
          </div>
        )}

        {(isLoaded || outsideRef) &&
          isShow &&
          Array.isArray(tags) &&
          tags.map((item, index) => (
            <a
              onClick={() => {
                replaceState.linkTo(item.url || url);
              }}
              key={index}
              style={{
                left: `${(item[0] || item.coordinate_x) * 100}%`,
                top: `${(item[1] || item.coordinate_y) * 100}%`,
                ...(item[2]
                  ? { width: `${item[2] * 100}%`, height: `${item[3] * 100}%` }
                  : {}),
              }}
              className={styles["ideas-card-tag"]}
            >
              <div>
                <Icon type="icont2_biaoqian" />
              </div>
            </a>
          ))}

        {showSwitch && isMobile && (
          <div
            onClick={() => setStateShowTag(!stateShowTag)}
            className={styles["ideas-card-switch"]}
          >
            <Icon type="icont2_biaoqian" />{" "}
            <FormattedMessage id={stateShowTag ? "Hide" : "Show"} />
          </div>
        )}

        {showMask && <div className={styles["ideas-mask"]} />}
      </div>

      {showTitle && (
        <div
          className={styles["ideas-card-title"]}
          style={{
            maxHeight: hover || showName ? "210px" : "0px",
            position: showName ? "initial" : "absolute",
            // padding: !outsideRef ? "0 8px" : "5px 8px",
          }}
        >
          <p>{name}</p>
          <p
            style={{
              display: "flex",
              alignItems: "center",
            }}
          >
            <Avatar src={designerAvatar ?? dilogoImg} />
            <a style={{ color: linkColor, marginLeft: 5 }}>
              {designerName ?? "未命名设计师"}
            </a>
          </p>
        </div>
      )}
    </div>
  );
};

export default React.memo(IdeaCard);
